"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.firtdTdBorder = exports.firstTdPl = exports.tdPl = exports.tdPr = exports.borderRadius = void 0;

var _react = require("@emotion/react");

var _util = require("../../util");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// For other components for table too
var borderRadius = (0, _util.rem)(6);
exports.borderRadius = borderRadius;
var tdPr = 16;
exports.tdPr = tdPr;
var tdPl = 1;
exports.tdPl = tdPl;
var firstTdPl = 13;
exports.firstTdPl = firstTdPl;
var firtdTdBorder = 3; // When the table content exceeds the screen width or container width make the table scroll horizontally.

exports.firtdTdBorder = firtdTdBorder;

var tableWrapper = function tableWrapper(theme) {
  return /*#__PURE__*/(0, _react.css)("display:block;max-width:100%;&>*{max-width:100%;max-height:100%;overflow:auto;box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);border-radius:", borderRadius, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:tableWrapper;"));
};

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("border-collapse:separate;border-spacing:0;width:100%;font-weight:", theme.fontWeight.medium, ";th,td{white-space:nowrap;}thead tr{th,th button{text-transform:uppercase;color:", theme.color.table.headText, ";}th{text-align:left;font-size:", theme.fontSize.xsmall, ";font-weight:inherit;letter-spacing:", theme.spacing[1], ";padding-top:", (0, _util.rem)(12), ";padding-bottom:", (0, _util.rem)(12), ";background-color:", theme.color.table.headBg, ";&:first-of-type{padding-left:", (0, _util.rem)(16), ";border-top-left-radius:", borderRadius, ";}&:last-of-type{border-top-right-radius:", borderRadius, ";}}}tbody tr{transition:background-color 0.3s;background-color:", theme.color.monochrome.white, ";&:nth-of-type(even){background-color:", theme.color.table.evenRowBg, ";}td{padding-top:", (0, _util.rem)(8), ";padding-bottom:", (0, _util.rem)(8), ";padding-right:", (0, _util.rem)(tdPr), ";height:", (0, _util.rem)(40), ";&:first-of-type{padding-left:", (0, _util.rem)(firstTdPl), ";transition:border-color 0.2s;border-left:", (0, _util.rem)(firtdTdBorder), " solid transparent;}&:not(:first-of-type){color:", theme.color.table.cellText, ";font-weight:", theme.fontWeight.normal, ";}&.disabled{opacity:0.65;}}strong{font-weight:", theme.fontWeight.medium, ";}&:not(.disabled):hover,&:not(.disabled).hover{background-color:", theme.color.table.rowHoverBg, ";td:first-of-type{border-left-color:", theme.color.table.rowHoverBorder, ";}}}&:not(.empty) tbody tr{td{&:first-of-type{color:", theme.color.table.firstCell, ";}}}tbody:last-child tr:last-of-type>td{&:first-of-type{border-bottom-left-radius:", borderRadius, ";}&:last-of-type{border-bottom-right-radius:", borderRadius, ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var separateTableWrapper = function separateTableWrapper(theme) {
  return /*#__PURE__*/(0, _react.css)("&>*{margin:-", theme.spacing[5], " 0;box-shadow:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:separateTableWrapper;"));
};

var separateTable = function separateTable(theme) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";border-spacing:0 ", (0, _util.rem)(8), ";background-color:transparent;box-shadow:none;padding:0 1px;thead tr,tbody tr{border-radius:", (0, _util.rem)(4), ";th:first-of-type,td:first-of-type{border-bottom-left-radius:", (0, _util.rem)(4), ";border-top-left-radius:", (0, _util.rem)(4), ";}th:last-of-type,td:last-of-type{border-bottom-right-radius:", (0, _util.rem)(4), ";border-top-right-radius:", (0, _util.rem)(4), ";}}thead tr{th{letter-spacing:", theme.spacing[2], ";padding-top:", (0, _util.rem)(8), ";padding-bottom:", (0, _util.rem)(8), ";&:first-of-type{padding-left:", (0, _util.rem)(16), ";}}}tbody tr{box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);&,&:nth-of-type(even):not(:hover):not(.hover){background-color:", theme.color.monochrome.white, ";}td{height:", (0, _util.rem)(48), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:separateTable;"));
};

var footer = function footer(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.table.rowBg, ";text-align:right;height:auto;padding:", (0, _util.rem)(8), " ", (0, _util.rem)(20), " ", (0, _util.rem)(8), " ", (0, _util.rem)(8), ";border-top:1px solid ", theme.color.table.footerBorder, ";box-shadow:0 1px 3px 0 rgba(", theme.color.monochrome.black_rgba, ", 0.15);border-bottom-left-radius:", borderRadius, ";border-bottom-right-radius:", borderRadius, ";&&>*{margin:0 ", (0, _util.rem)(4), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:footer;"));
};

var handle = function handle(theme) {
  return /*#__PURE__*/(0, _react.css)("cursor:move;cursor:-webkit-grabbing;color:", theme.color.monochrome.mediumDark, ";svg{width:", (0, _util.rem)(24), ";height:", (0, _util.rem)(24), ";vertical-align:middle;}&:hover{color:", theme.color.monochrome.black, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:handle;"));
};

var empty = /*#__PURE__*/(0, _react.css)("thead tr{border-bottom-right-radius:", (0, _util.rem)(4), ";border-top-right-radius:", (0, _util.rem)(4), ";}tbody tr{pointer-events:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:empty;")); // Remove the top radius from table, because header will have them

var withHeader = process.env.NODE_ENV === "production" ? {
  name: "yime2e",
  styles: "&&&>*{border-top-left-radius:0;border-top-right-radius:0;thead tr th{&:first-of-type{border-top-left-radius:0;}&:last-of-type{border-top-right-radius:0;}}}"
} : {
  name: "43a4pt-withHeader",
  styles: "&&&>*{border-top-left-radius:0;border-top-right-radius:0;thead tr th{&:first-of-type{border-top-left-radius:0;}&:last-of-type{border-top-right-radius:0;}}};label:withHeader;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var withFooter = process.env.NODE_ENV === "production" ? {
  name: "kyzld5",
  styles: "&&&>*{border-bottom-left-radius:0;border-bottom-right-radius:0;tbody tr:last-of-type td{&:first-of-type{border-bottom-left-radius:0;}&:last-of-type{border-bottom-right-radius:0;}}}"
} : {
  name: "1erkj1e-withFooter",
  styles: "&&&>*{border-bottom-left-radius:0;border-bottom-right-radius:0;tbody tr:last-of-type td{&:first-of-type{border-bottom-left-radius:0;}&:last-of-type{border-bottom-right-radius:0;}}};label:withFooter;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var disabled = process.env.NODE_ENV === "production" ? {
  name: "dq9zfx",
  styles: "tbody{opacity:0.5;tr{pointer-events:none;}}"
} : {
  name: "on6t42-disabled",
  styles: "tbody{opacity:0.5;tr{pointer-events:none;}};label:disabled;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var disabledCell = process.env.NODE_ENV === "production" ? {
  name: "19nzzeh",
  styles: "opacity:0.65"
} : {
  name: "1q97ak0-disabledCell",
  styles: "opacity:0.65;label:disabledCell;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var draggingCell = function draggingCell(theme) {
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.secondary.brand, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:draggingCell;"));
};

var styles = {
  tableWrapper: tableWrapper,
  base: base,
  separateTableWrapper: separateTableWrapper,
  separateTable: separateTable,
  footer: footer,
  handle: handle,
  empty: empty,
  withHeader: withHeader,
  withFooter: withFooter,
  disabled: disabled,
  disabledCell: disabledCell,
  draggingCell: draggingCell
};
exports.styles = styles;
//# sourceMappingURL=Table.styles.js.map